import { AnimatedSection } from "./AnimatedSection";
import { analytics } from "@/lib/analytics";

export function FinalClose({ openModal }) {
  return (
    <section className="py-24 md:py-36 bg-[#050A07] relative" data-testid="final-close-section">
      <div className="absolute inset-0 z-0 opacity-10">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/6d886167-72b0-4f6c-ba62-cd5d97afce73/images/8cd542e2bcdbeb413247e08ae7f6d92aecf7f463f570fe847e4adac6bf5484ca.png"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <AnimatedSection>
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            The next layer of trade is being built now
          </h2>
          <p className="mt-6 text-[#A1B2A8] text-base lg:text-lg leading-relaxed max-w-2xl mx-auto">
            Those who move early gain access, visibility, and advantage.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => { analytics.ctaClicked("Apply as Buyer", "final_close"); openModal("buyer"); }}
              className="bg-[#16A34A] text-white hover:bg-[#15803D] transition-all px-10 py-4 font-medium font-['Outfit'] text-base w-full sm:w-auto"
              data-testid="final-apply-buyer-btn"
            >
              Apply as Buyer
            </button>
            <button
              onClick={() => { analytics.ctaClicked("Apply as Supplier", "final_close"); openModal("supplier"); }}
              className="bg-transparent border border-[#22C55E] text-[#22C55E] hover:bg-[#22C55E]/10 transition-all px-10 py-4 font-medium font-['Outfit'] text-base w-full sm:w-auto"
              data-testid="final-apply-supplier-btn"
            >
              Apply as Supplier
            </button>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
